import { provideLocal, injectLocal } from '@vueuse/core';
import { useBrand } from '~/composables/useBrand';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';
import { getBigTicketZipCookie } from '~/utils/cookiesUtils';
import { AVAILABILITY_BT_CONSTS } from '../consts/btConsts';
import { BT_ATB_VALIDATOR_REPOSITORY } from '../consts/providers';

/** @typedef {import('~/modules/add-to-bag/types').PayloadValidator} PayloadValidator */

export const useBigTicketATBValidatorProvide = () => {
  const { isMcom } = useBrand();
  const { isBigTicketItemFlag } = useProductFlags();

  /**
   * @returns {null | string}
   */
  const bigTicketATBValidator = () => {
    if (!isBigTicketItemFlag) return null;
    if (isBigTicketItemFlag && !getBigTicketZipCookie()) {
      return isMcom ? AVAILABILITY_BT_CONSTS.INVALID_ZIPCODE_MCOM : AVAILABILITY_BT_CONSTS.INVALID_ZIPCODE_BCOM;
    }
    return null;
  };

  provideLocal(BT_ATB_VALIDATOR_REPOSITORY, bigTicketATBValidator);
};

export const useBigTicketATBValidator = () => {
  /**
   * @type {PayloadValidator<void>}
   */
  const bigTicketATBValidator = injectLocal(BT_ATB_VALIDATOR_REPOSITORY);
  if (typeof bigTicketATBValidator === 'undefined') {
    throw new TypeError('useBigTicketATBValidator() is called without provider.');
  }

  return { bigTicketATBValidator };
};
